<template>
    <div class="header-div">
        <div class="title" @click="jumpTo('home')">{{libraryName}}</div>
        <div class="menu-btns">
            <div class="btn" @click="jumpTo('home')" :class="[currentMenu === 'home' ? 'active': '']">首页</div>
            <div class="btn" @click="jumpTo('book')" :class="[currentMenu === 'book' ? 'active': '']">文献</div>
            <!-- <div class="btn" @click="jumpTo('paper')" :class="[currentMenu === 'paper' ? 'active': '']">报纸</div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['currentMenu'],
    data () {
		return {
            libraryName: this.global.getLibraryInfos().name,
            searchValue: ''
		}
	},
    methods: {
        jumpTo (page) {
            // this.$router.push({ name: page })
            let routeUrl = this.$router.resolve({
                name: page
            })
            window.open(routeUrl.href, '_blank')
        },
        search () {
            this.$bus.$emit('searchText', this.searchValue);
        }
    }
};
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.header-div {
    width: 100%;
    height: 80 * @uh;
    background: rgb(248, 248, 248);
    font-size: 28 * @uw;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding-right: 100 * @uw;

    .title {
        margin-left: 200 * @uw;
        cursor: pointer;
    }

    .menu-btns {
        width: 350 * @uw;
        display: flex;
        margin-left: 100 * @uw;
        // justify-content: flex-end;
        // justify-content: space-between;
        // flex-direction: row-reverse;
        font-size: 20 * @uw;
        // margin-right: 200 * @uw;

        .search-input {
            width: 300 * @uw;
            border: 1px solid rgb(126, 161, 172);
            border-radius: 5px;
        }

        .btn {
            cursor: pointer;
            width: 60 * @uw;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 30 * @uw;
        }

        .active {
            color: #a40100!important;
            font-weight: bold;
        }
    }
}

/deep/ .el-input__suffix {
	display: flex;
	align-items: center;
	margin-right: -5px;
	border-radius: 5px;
	padding: 0px 10px 0px 10px;
	background: rgb(141,94,26);
    cursor: pointer;
}
</style>
